import { render } from "./index.vue?vue&type=template&id=5c1aeca4&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5c1aeca4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c1aeca4"

export default script